export const OFFLINE_PHOTO_PREFIX = "offline:";

export type OfflineMutationType = "toggle_task" | "task_photo" | "task_note" | "create_issue";

export type ToggleTaskPayload = {
  originTaskId: string;
  stepId: string;
  stepName: string;
  completed: boolean;
  orgId: string;
  isExtraTask?: boolean;
};

export type TaskPhotoPayload = {
  originTaskId: string;
  stepId: string;
  stepName: string;
  orgId: string;
  fileName: string;
};

export type TaskNotePayload = {
  originTaskId: string;
  stepId: string;
  stepName: string;
  orgId: string;
  note: string;
};

export type CreateIssuePayload = {
  locationId: string;
  orgId: string;
  reporterId: string;
  description: string;
  sectionName?: string;
};

export type OfflineMutation = {
  id: string;
  type: OfflineMutationType;
  createdAt: number;
  payload: ToggleTaskPayload | TaskPhotoPayload | TaskNotePayload | CreateIssuePayload;
  photoBlobId?: string;
};

export function offlinePhotoRef(blobId: string): string {
  return `${OFFLINE_PHOTO_PREFIX}${blobId}`;
}

export function parseOfflinePhotoRef(value: string): string | null {
  if (!value.startsWith(OFFLINE_PHOTO_PREFIX)) return null;
  const id = value.slice(OFFLINE_PHOTO_PREFIX.length).trim();
  return id || null;
}

export function isNetworkFailure(error: unknown): boolean {
  if (typeof navigator !== "undefined" && navigator.onLine === false) return true;
  if (error instanceof TypeError) return true;
  const message =
    error instanceof Error
      ? error.message
      : error && typeof error === "object" && "message" in error
        ? String((error as { message: unknown }).message)
        : String(error ?? "");
  const lower = message.toLowerCase();
  return (
    lower.includes("offline") ||
    lower.includes("failed to fetch") ||
    lower.includes("network") ||
    lower.includes("timeout") ||
    lower.includes("timed out") ||
    lower.includes("aborterror")
  );
}
